import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { FormattedMessage } from 'react-intl';
import { QuizAnswer } from '../../../../types/quiz';
import { H4 } from '@osmosis/react-ui/components/Text';
import { AnsweredItem } from './AnsweredItem';

/**
 * AnsweredTable.
 */
export const AnsweredItems = ({
  isCorrect,
  answers,
  correctAnswers,
}: {
  isCorrect: boolean;
  answers: QuizAnswer[];
  correctAnswers: QuizAnswer[];
}) => {
  const color = useColors();

  return (
    <Flex
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {[
        {
          key: '1',
          header: (
            <H4 mb={3} sx={{ ':last-child': { color: 'red' } }}>
              <FormattedMessage
                id="quiz.quiz.dnd.answered"
                defaultMessage="Your response is "
              />

              <Box as="span" color={isCorrect ? 'positive' : 'negative'}>
                {isCorrect ? (
                  <FormattedMessage
                    id="quiz.quiz.dnd.answered.variant.correct"
                    defaultMessage="correct"
                  />
                ) : (
                  <FormattedMessage
                    id="quiz.quiz.dnd.answered.variant.incorrect"
                    defaultMessage="incorrect"
                  />
                )}
              </Box>
            </H4>
          ),

          values: answers,
        },
        {
          key: '2',
          header: (
            <H4 mb={3} color="positive">
              <FormattedMessage
                id="quiz.quiz.dnd.correct"
                defaultMessage="Correct response"
              />
            </H4>
          ),

          values: correctAnswers,
        },
      ].map(({ header, values, key }) => (
        <Box
          key={key}
          sx={{
            ':first-child': {
              mr: '15px',
            },
          }}
        >
          {header}
          <Flex
            sx={{
              border: `1px solid ${color.gray20}`,
              borderRadius: '5px',
              width: '250px',
              minHeight: '400px',
              overflow: 'auto',
              position: 'relative',
              height: 'auto',
              flexDirection: 'column',
            }}
          >
            {values.map((i) => {
              return (
                <AnsweredItem
                  key={i.text}
                  text={i.text}
                  explanation={i.explanation}
                />
              );
            })}
          </Flex>
        </Box>
      ))}
    </Flex>
  );
};
